import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import Http from '../../../../Http';
import { Button, Dialog, DialogActions, DialogContent, FormControlLabel, Icon, IconButton, Input, Radio, RadioGroup } from '@material-ui/core';
import PagoSucursal from './PagoSucursal';

export default function PagosSucursales() {
  const Params = useParams();
  const [Cliente, setCliente] = useState({});
  const [RadioLoading, setRadioLoading] = useState(false);
  const [ModalSucursal, setModalSucursal] = useState({ visible: false });

  useEffect(() => {
    loadCliente();

    // eslint-disable-next-line
  }, [])

  const loadCliente = async () => {
    let Res = await Http.get(`cliente/${Params.id}/pago-transportista`);
    if (!Res.error) {
      console.log(Res.data)
      setCliente(Res.data || {});
    }
  }

  const onTipoChange = async (value) => {
    console.log(value)
    setRadioLoading(true);
    try {
      let data = { id: Params.id, cliente_pt_tipo: value };
      let Res = await Http.post(`cliente/save`, data);
      if (!Res.error) {
        console.log('saved', Res.data.data);
        setCliente({ ...Res.data.data, cliente_pt_tipo: parseInt(Res.data.data.cliente_pt_tipo) });
      }
    } catch (error) {
      console.log(error)
    }
    setRadioLoading(false);
  }

  const onAddSucursal = () => {
    setModalSucursal({ visible: true });
  }

  const onAddSucursalClose = () => {
    setModalSucursal({ visible: false });
  }

  const onSucursalSave = () => {
    loadCliente();
    setModalSucursal({ visible: false });
  }

  const onEditSucursal = (suc) => {
    setModalSucursal({ visible: true, sucursal: suc });
  }

  const onDeleteSucursal = async (suc) => {
    try {
      console.log(suc);
      let res = await Http.post(`cliente/${Cliente.id}/pago-transportista/sucursal/delete`, {
        ...suc
      });
      console.log(res);
      if (!res.error)
        loadCliente();
    } catch (error) {
      console.log(error)
    }
  }

  const onSavePieza = async () => {
    try {
      let data = { id: Params.id, cliente_pt_importe_pieza: Cliente.cliente_pt_importe_pieza };
      let Res = await Http.post(`cliente/save`, data);
      if (!Res.error) {
        console.log('saved', Res.data.data);
        // setCliente({ ...Res.data.data, cliente_pt_tipo: parseInt(Res.data.data.cliente_pt_tipo) });
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <RadioGroup autoFocus={true} value={Cliente.cliente_pt_tipo || 1} onChange={(e) => onTipoChange(e.target.value)}  >
          <FormControlLabel value={1} control={<Radio />} label={'Normal'} disabled={RadioLoading} />
          <FormControlLabel value={2} control={<Radio />} label={'Por sucursal'} disabled={RadioLoading} />
          <FormControlLabel value={3} control={<Radio />} label={'Por pieza'} disabled={RadioLoading} />
        </RadioGroup>
      </div>

      {
        Cliente.cliente_pt_tipo === 2 && (
          <div>
            <div style={{ textAlign: 'right' }}>
              <Button color='primary' variant='contained' onClick={onAddSucursal}>Agregar sucursal</Button>
            </div>
            <div style={{ margin: 'auto', width: 'fit-content' }}>
              {
                Cliente.pt_sucursales?.map((sucursal, si) => (
                  <div key={sucursal.id} style={{ display: 'flex', alignItems: 'end', padding: '5px 10px', backgroundColor: '#d4d4d4', marginBottom: 8, borderRadius: 7 }}>
                    <p>{sucursal.sucursal_nombre} - {sucursal.porcentaje}%</p>
                    <div style={{ display: 'flex' }}>
                      <IconButton onClick={() => onEditSucursal(sucursal)} size='small'><Icon>edit</Icon></IconButton>
                      <IconButton onClick={() => onDeleteSucursal(sucursal)} size='small'><Icon>delete</Icon></IconButton>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        )
      }

      {
        Cliente.cliente_pt_tipo === 3 && (
          <div style={{ textAlign: 'center' }}>
            <Input placeholder='Pago por pieza' value={Cliente.cliente_pt_importe_pieza || 0} onChange={(e) => setCliente({ ...Cliente, cliente_pt_importe_pieza: e.target.value })} />
            <Button onClick={onSavePieza}>Guardar</Button>
          </div>
        )
      }


      <Dialog
        onClose={onAddSucursalClose}
        open={ModalSucursal?.visible}
        fullWidth={true}
        maxWidth={"xl"}
      >
        <DialogContent dividers>
          <PagoSucursal
            idCliente={Cliente.id}
            sucursal={ModalSucursal.sucursal}
            onSave={onSucursalSave}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onAddSucursalClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
